import Vue from "vue";
import Vant, { Toast, Dialog } from "vant";
import "vant/lib/index.css";
import App from "./App.vue";
import router from "./router";
import "./styles/global.css";

Vue.config.productionTip = false;

Vue.use(Vant);

Vue.prototype.$toast = Toast;
Vue.prototype.$dialog = Dialog;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
